import type { ViduV1GetTaskStateReply } from '@/app/services/vidu';

export type TaskStateInfo = ViduV1GetTaskStateReply;

export type DisplayTaskState =
  | Exclude<TaskStateInfo['state'], 'created' | 'preparation' | 'scheduling' | 'unspecified'>
  | 'fetchingTaskDetail';

export enum ActionButtonType {
  SUBMIT = 'submit',
  DOWNLOAD = 'download',
  UPSCALE = 'upscale',
  FRAME_SHOT = 'frameShot',
  SHARE = 'share',
  ELLIPSIS_MENU = 'ellipsisMenu',
  STAR = 'star',
  EXTEND = 'extend',
  QUICK_EDIT = 'quickEdit',
  TRANSFORM_TO_ELEMENT = 'transformToElement',
}
